<template>
  <div class="middle cadfm-flexitem-stretched">
    <action-panel>
      <action-bar>
        <b-navbar-nav>

          <action-button @click="back" icon="back" bold :text="lang.button_Back" :tooltip="lang.button_Back"
            :disabled="backButtonStatus" />
          <action-button v-if="typeOfPart == 'Electric'" @click="createAssembly" icon="new" bold
            :text="lang.button_NewAssembly" :tooltip="lang.button_NewAssembly" :disabled="createAssemblyButtonStatus" />
          <action-button v-if="typeOfPart != 'Electric'" @click="assignAssembly" icon="new" bold
            :text="lang.button_AssignAssembly" :tooltip="lang.button_AssignAssembly"
            :disabled="assignAssemblyButtonStatus" />




        </b-navbar-nav>
        <b-navbar-nav class="ml-auto">
          <action-button v-show="!$parent.isVisibleLeft" @click="toggleLeftPanel" icon="show" bold
            :text="lang.button_Left" :tooltip="lang.button_Left" :disabled="toggleButtonStatus" />
          <action-button v-show="!$parent.isVisibleRight" @click="toggleRightPanel" icon="show" bold
            :text="lang.button_Right" :tooltip="lang.button_Right" :disabled="toggleButtonStatus" />

        </b-navbar-nav>
      </action-bar>
      <action-content>
        <Content :lang="lang.Content"></Content>
      </action-content>
    </action-panel>
  </div>
</template>

<script>
  import ActionBar from '@/components/shared/ActionBar'
  import ActionButton from '@/components/shared/ActionButton'
  import ActionContent from '@/components/shared/ActionContent'
  import ActionPanel from '@/components/shared/ActionPanel'


  import Content from "@/components/PartManager/Views/PartAssembly/Middle/Content/Content"

//import { mapState, mapMutations, mapActions, mapGetters } from 'vuex'

export default {
  name: 'Middle',
  components:{
    ActionBar,
    ActionButton,
    ActionContent,
    ActionPanel,
    Content

  },
  props:{
    lang: Object
  },

  data () {
    return {
      toggleButtonStatus: false,
      createAssemblyButtonStatus: false,
      assignAssemblyButtonStatus: true,
      backButtonStatus: false,
      imported: false,
      buttonStatus: 0,
      isAssigned: false,
      isCreated: false
    }
  },
  computed:{
    typeOfPart(){
      let type = "";  
      for (let prop in this.$store.getters.selectedRows[0]){
        
        if (this.$store.getters.selectedRows[0][prop].type == "type"){
          type = this.$store.getters.selectedRows[0][prop].value.display;
          break;
        }
      }    

      return type;
    },
    selectedAssemblyRow(){
      return this.$store.getters.selectedAssemblyRow;
    }
    
  },
  created() {

    
  },
  watch: {
    selectedAssemblyRow: function (newVal, oldVal) {
        

        if (this.selectedAssemblyRow.revisionId != undefined){
          this.assignAssemblyButtonStatus = false;
        }else{
          this.assignAssemblyButtonStatus = true;
        }
    }

  },
  methods: {
    createAssembly(){
      

      let vue = this;

      const obj = {
        partRevisionId: this.$store.getters.selectedRows[0].col___revisionId.revisionId,
        partNumber: this.$store.getters.newAssemblyForm.PartNumber
      }
     

      this.$store.dispatch(this.$store.getters.sectionPrefix + "_createAssembly", obj)
      .then ((result) => {

       console.log(result)

        if (result.status == "OK"){

          if (result.data != null){
            let obj = {
              text: vue.lang.alert_success_CreateAssembly,
              time: 10,
              type: "success"
            }

            vue.$store.dispatch("displayFooterAlert", obj);

            vue.isCreated = true;

            vue.toDetails(result.data);

          }else{
            
            let obj = {
              text: vue.lang.alert_error_CreateAssembly,
              time: 15,
              type: "danger"
            }

            vue.$store.dispatch("displayFooterAlert", obj);
          }
          
        }else{
          let text = vue.lang.alert_error_CreateAssembly;
            
          if (result.message != undefined){
            text = vue.lang.alert_error_CreateAssembly + ": " + result.message;
          }
          let obj = {
              text: text,
              time: 15,
              type: "danger"
            }

            vue.$store.dispatch("displayFooterAlert", obj);
        }


     })


    },
    
    toDetails(goalObj) {
      this.$store.dispatch("resetPropertyToSaving");

      this.$store.dispatch("deleteAllSelectedRows");

      let to = "/PartManager/PartDetails";
      let obj = {
        col___revisionId: {
          revisionId: goalObj.revisionId,
          partId: goalObj.partId
        },
        col___revision: {
          revisionId: 1

        },
        col___status: {
          assembly: true

        }
      }

      this.$store.dispatch("setSelectedRows", [obj]);

      this.$store.dispatch("setOuterData", true);

      this.$store.dispatch("editPropertiesForm", false);





      const query = {
        from: this.$route.path,
        to: to,
        end: true,
        revisionId: goalObj.revisionId,
        partId: goalObj.partId
      }

      this.$router.push({ path: to, query: query });

    },
    
    back(){

      if (this.isAssigned == true || this.isCreated){
        const reloadObj = {
          status: true,
          name: "DataTableFilteredOnApiComponent"
        }
        this.$store.dispatch("reloadAfterActionComplex", reloadObj);
      }

      let to = this.$route.query.from;
      
      

      
      const query = {
        from: this.$route.path,
        to: to,

      }

      this.$router.push({ path: to, query: query })
    },
    toggleRightPanel(){

      this.$parent.isVisibleRight = !this.$parent.isVisibleRight;
 
    },
    toggleLeftPanel(){

      this.$parent.isVisibleLeft = !this.$parent.isVisibleLeft;
 
    }
  }
}
</script>


<style scoped>

  .middle{
    border-right: 1px solid #666;
  }

</style>



// WEBPACK FOOTER //
// src/components/PartManager/Views/PartAssembly/Middle/Middle.vue